import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getIsAuth, getIsAuthPending } from 'redux/reducers/auth/selectors';
import { IS_NEMAN } from 'services/constants/env';
import { authManager } from 'services/auth';
import { LoginForm } from 'components/LoginForm';
import { SignedOut } from 'components/SignedOut';
import { EASSpinner } from 'components/EASSpinner';
import { DEFAULT_AUTHORIZED_PATH } from 'routes/constants';

export const LoginPage: FC = () => {
	const navigate = useNavigate();
	const ifAuth = useSelector(getIsAuth);
	const isPending = useSelector(getIsAuthPending);

	const wasSignedOut = authManager.isSignedOut();

	useEffect(() => {
		if (ifAuth) {
			navigate(DEFAULT_AUTHORIZED_PATH, { replace: true });
			return;
		}

		// A retry after a failed handshake must land back where the user was going, not at home.
		if (!IS_NEMAN && !isPending && !wasSignedOut) {
			void authManager.loginRedirect(authManager.getPendingReturnTo() ?? DEFAULT_AUTHORIZED_PATH);
		}
	}, [ifAuth, isPending, wasSignedOut, navigate]);

	if (IS_NEMAN) return <LoginForm />;
	if (wasSignedOut) return <SignedOut />;

	return <EASSpinner />;
};
